import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const LogoutIconSvg = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 10.5H17.5M17.5 10.5L14.875 7.875M17.5 10.5L14.875 13.125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 10.5C3.5 8.64348 4.2375 6.86301 5.55025 5.55025C6.86301 4.2375 8.64348 3.5 10.5 3.5M10.5 17.5C9.45051 17.5009 8.41429 17.2655 7.46829 16.811C6.52229 16.3566 5.69082 15.6949 5.03563 14.875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoutIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={LogoutIconSvg} {...props} />
);

export default LogoutIcon;

LogoutIcon.displayName = "LogoutIcon";
